angular.module('rjmNg.api').factory 'ReportViews', [
  "$http"
  "serviceUrl"
  (
    $http
    serviceUrl
  ) ->

    defaultParams =
      withCredentials: true
      headers:
        Accept: 'application/json'
        'Content-Type': 'application/json'

    logDashboardView: (dashboardId) ->
      $http angular.extend {}, defaultParams,
        method: 'POST'
        url: serviceUrl("/dashboards/#{dashboardId}/log-view")
]
